import { Component, OnInit } from '@angular/core';
import { IFilterAngularComp } from 'ag-grid-angular';
import { IFilterParams, IDoesFilterPassParams } from 'ag-grid-community';
import { AppSide } from 'src/app/constants';
import { SharedService } from 'src/app/shared/shared.service';

@Component({
  selector: 'app-wf-status-filter',
  templateUrl: './wf-status-filter.component.html',
  styleUrls: ['./wf-status-filter.component.scss']
})
export class WfStatusFilterComponent implements IFilterAngularComp {

  params: IFilterParams;

  filterText = '';

  selectedState = 'All';

  destroySubscription = false;

  workflow_statuses: Array<string>;

  constructor(private sharedService: SharedService) { }

  agInit(params: IFilterParams): void {
    this.params = params;
    const fromSide = this.params.context.componentParent.formSide;
    let metadata;
    if (fromSide === AppSide.manageSide) {
      metadata = this.sharedService.getMetadata();
    } else if (fromSide === AppSide.storeSide) {
      metadata = this.sharedService.getStoreMetadata();
    }
    this.workflow_statuses = metadata.workflow_statuses ? metadata.workflow_statuses : [];
  }

  isFilterActive(): boolean {
    return this.selectedState != 'All';
  }

  doesFilterPass(params: IDoesFilterPassParams): boolean {
    const { node } = params;
    const nodeData = { node };
    const value = nodeData.node.data.status;
    return value;
  }

  getModel() {
    if (!this.isFilterActive()) {
      return null;
    }
    return { value: this.selectedState };
  }

  setModel(model: any) {
    this.selectedState = model == null ? null : model.value;
  }

  onChange(newValue: any) {
    this.selectedState = newValue;
    this.params.filterChangedCallback();
  }

  destroy() {
    this.destroySubscription = true;
  }


}
